export * from './rest.service';
export * from './account.service';
export * from './app.config';
export * from './category.service';
export * from './change-filters.service';
export * from './cookbook.service';
export * from './cookie.service';
export * from './drag-drop.service';
export * from './files.service';
export * from './images.service';
export * from './mail.service';
export * from './planning.service';
export * from './popup.service';
export * from './product.service';
export * from './profile.service';
export * from './recipe.service';
export * from './spinner.service';
export * from './tarif.service';
export * from './landing.service';
export * from './datepicker.service';
export * from './LowerCaseUrlSerializer';
export * from './intro.service';
export * from './dynamicScriptLoaderService';



// WEBPACK FOOTER //
// ./src/app/shared/services/index.ts